// utils/langRouting.js — zentrale Helfer für das Sprach-URL-Präfix-Schema.
//
// Englisch bleibt unpräfixiert (z.B. /gallery), die anderen 9 Sprachen bekommen
// ein Pfad-Präfix (z.B. /de/gallery). Kein React-Import nötig, überall
// wiederverwendbar (App.js, Header.js, BottomNav.js, SEO.js, ...).

export const NON_EN_LANGS = ["de", "it", "ja", "es", "pt", "fr", "ru", "pl", "tr"];
export const ALL_LANGS = ["en", ...NON_EN_LANGS];

// "/de/gallery" -> { lang: "de", basePath: "/gallery" }
// "/gallery"    -> { lang: "en", basePath: "/gallery" }
export function splitLangPrefix(pathname) {
  const parts = (pathname || "").split("/").filter(Boolean);
  if (parts.length && NON_EN_LANGS.includes(parts[0])) {
    return { lang: parts[0], basePath: "/" + parts.slice(1).join("/") };
  }
  return { lang: "en", basePath: pathname || "/" };
}

// ("de", "/gallery") -> "/de/gallery"
// ("en", "/gallery") -> "/gallery"
export function buildLocalizedPath(lang, basePath) {
  const clean = basePath === "/" ? "" : basePath;
  return lang === "en" ? clean || "/" : `/${lang}${clean}`;
}

// Gesetzt, sobald der Nutzer aktiv über den Sprachschalter eine Sprache wählt
// (Header.js) — getrennt vom normalen i18next-localStorage-Cache ("i18nextLng"),
// der bei jedem Seitenaufruf durch die aktuell besuchte URL überschrieben wird
// und sich deshalb NICHT als "hat der Nutzer das bewusst gewählt"-Signal eignet.
export const LANG_OVERRIDE_KEY = "aof-lang-override";

// Browsersprache direkt aus navigator lesen (nicht i18n.language, das bevorzugt
// den ggf. veralteten localStorage-Cache vor der tatsächlich aktuellen
// Browsereinstellung) — liefert einen unterstützten Nicht-Englisch-Code oder null.
export function detectBrowserLang() {
  if (typeof navigator === "undefined") return null;
  const candidates = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const l of candidates) {
    const code = l?.slice(0, 2).toLowerCase();
    if (code && NON_EN_LANGS.includes(code)) return code;
  }
  return null;
}
